import React from 'react';
import style from './style.scss';
import Modal from 'react-modal';
import {ListProductDetailImage} from 'components/product-detail/sub-view/list-product-detail-image';
import {ProductInfo} from './product-info';
import {ProductInfoCollapse} from './product-info-collapse';
import {SameProduct} from './same-product';
import {OtherProduct} from './other-product';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {closePopupProductDetail} from 'actions';
import {LoadingPage} from 'components/loading-page';

class ProductPopupDetail extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      pathName: '',
      pathNameNews: ''
    };
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.setState({pathName: window.location.pathname});
    window.history.replaceState(null, null, `/san-pham/${this.props.product.nameSlug}/${this.props.product.id}`);
  }

  componentWillReceiveProps(nextProps) {
    window.history.replaceState(null, null, `/san-pham/${nextProps.product.nameSlug}/${nextProps.product.id}`);
  }

  closeModal() {
    this.props.dispatch(closePopupProductDetail());
    window.history.replaceState(null, null, this.state.pathName);
    window.scrollTo(0, this.props.scrollY);
  }

  render() {
    const styles = {
      content : {
        top: '0',
        left: '0',
        right: '0',
        bottom: '0'
      }
    };
    return (
      <div className="product-popup-wrap">
        <Modal
          isOpen={this.props.isOpen}
          onRequestClose={this.closeModal}
          style={styles}
          className="product-popup-container">
          <LoadingPage isShow={this.props.isLoadingPopup} />
          <div className="product-popup">
            <button className="button-close-popup" onClick={this.closeModal}></button>
            <div className="product-popup-left-sider">
              <ListProductDetailImage images={this.props.product.images}/>
            </div>
            <div className="product-popup-right-detail">
              <ProductInfo {...this.props.product}/>
              <ProductInfoCollapse productContent={this.props.product.introduction}/>
              <SameProduct categoryId={this.props.product.categoryIds[0]} productId={this.props.product.id}/>
              {this.props.product.business && <OtherProduct businessId={this.props.product.businessId} productId={this.props.product.id}/>}
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    product: state.popupProduct.data,
    isOpen: state.popupProduct.isOpen,
    scrollY: state.popupProduct.scrollY,
    isLoadingPopup: state.popupProduct.isLoading
  };
};

export default connect(mapStateToProps)(ProductPopupDetail);



// WEBPACK FOOTER //
// ./components/partials/product/popup-view-detail/ProductPopupDetail.jsx